module.exports = __webpack_public_path__ + "static/ttc-complaints.4c7e84eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ttc-complaints.jpg
// module id = ./src/assets/ttc-complaints.jpg
// module chunks = 246384609461072